module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-ac0ee2d1.png";